import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const Terminate = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1ZM14.1465 5.14648C14.3417 4.95122 14.6583 4.95122 14.8535 5.14648C15.0488 5.34175 15.0488 5.65825 14.8535 5.85352L10.707 10L14.8535 14.1465C15.0488 14.3417 15.0488 14.6583 14.8535 14.8535C14.6583 15.0488 14.3417 15.0488 14.1465 14.8535L10 10.707L5.85352 14.8535C5.65825 15.0488 5.34175 15.0488 5.14648 14.8535C4.95122 14.6583 4.95122 14.3417 5.14648 14.1465L9.29297 10L5.14648 5.85352C4.95122 5.65825 4.95122 5.34175 5.14648 5.14648C5.34175 4.95122 5.65825 4.95122 5.85352 5.14648L10 9.29297L14.1465 5.14648Z"
		/>
	</SvgIcon>
);
